<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pd-10 bg-white mgb-30">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单编号">
          <el-input
            v-model="form.orderNo"
            clearable
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="SIM卡号">
          <el-input
            v-model="form.iccid"
            clearable
            placeholder="请输入SIM卡号"
          ></el-input>
        </el-form-item>

        <el-form-item label="运营商">
          <el-select v-model="form.operator" clearable placeholder="全部">
            <el-option label="移动" value="移动"></el-option>
            <el-option label="联通" value="联通"></el-option>
            <el-option label="电信" value="电信"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="form.equipmentNum"
            clearable
            placeholder="请输入设备编号"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单状态">
          <el-select v-model="form.state" clearable placeholder="全部">
            <el-option label="未支付" value="1"></el-option>
            <el-option label="已支付" value="2"></el-option>
            <el-option label="已到账" value="3"></el-option>
            <el-option label="已退款" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟进状态">
          <el-select v-model="form.followStatus" placeholder="全部" clearable>
            <el-option label="未跟进" value="1"></el-option>
            <el-option label="已跟进" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="mgl-30">
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      :cell-style="cellStayle"
    >
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
      <el-table-column prop="iccid" label="SIM卡号"> </el-table-column>

      <el-table-column prop="operator" label="运营商"> </el-table-column>
      <el-table-column prop="equipmentNum" label="设备编号"> </el-table-column>
      <el-table-column prop="packageName" label="套餐名称"> </el-table-column>
      <el-table-column prop="packageSizeNum" label="套餐大小(MB)">
      </el-table-column>
      <el-table-column prop="orderPrice" label="套餐金额(元)">
      </el-table-column>
      <el-table-column prop="comboType" label="订单状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.state == 1
                ? '未支付'
                : scope.row.state == 2
                ? '已支付'
                : scope.row.state == 3
                ? '已到账'
                : scope.row.state == 4
                ? '已退款'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column prop="comboType" label="到账时间">
        <template slot-scope="scope">
          <span
            v-text="scope.row.accountTime ? scope.row.accountTime : '- -'"
          ></span>
        </template>
      </el-table-column>
      <!-- <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleDetail(scope.row)" type="text" size="small"
            >详情</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 详情弹框 -->
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="30%"
      center
      top="30vh"
    >
      <el-descriptions title="" border column="1">
        <el-descriptions-item label="套餐名称"
          >kooriookami</el-descriptions-item
        >
        <el-descriptions-item label="套餐大小"
          >18100000000</el-descriptions-item
        >
        <el-descriptions-item label="有效时长">苏州市</el-descriptions-item>
        <el-descriptions-item label="套餐金额">苏州市</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      tableData: [],

      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      form: {},
      dialogVisible: false,
      companyId: null,
    };
  },
  created() {
    this.getROLE();
    this.getList();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.companyId = token.companyId;
      }
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.sim
        .topOrderList({
          pageNum: this.page,
          pageSize: this.pageSize,
          companyId: this.companyId,
          endTime: this.form.endTime,
          equipmentNum: this.form.equipmentNum,
          followStatus: this.form.followStatus,
          iccid: this.form.iccid,
          operator: this.form.operator,
          orderNo: this.form.orderNo,
          startTime: this.form.startTime,
          state: this.form.state,
          type: this.form.type,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },

    // 根据条件判断字段颜色
    cellStayle(row, colum, rowIndex, columnIndex) {
      if (row.row.status === 2 && row.columnIndex == 7) {
        return "color:orange";
      } else if (row.row.status === 1 && row.columnIndex == 7) {
        return "color:red";
      } else if (row.row.status === 3 && row.columnIndex == 7) {
        return "color:green";
      } else {
        return;
      }
    },
    reset() {
      this.form = { startTime: "", endTime: "" };
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
